module.exports = __webpack_public_path__ + "img/2.b484bcca.jpg";